import { AppInsightsErrorBoundary } from "@microsoft/applicationinsights-react-js";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import React from "react";
import { reactPlugin } from "./appInsights";

interface WrapperProps {
  children?: React.ReactNode;
}

const queryClient = new QueryClient();

function ErrorDisplay() {
  return <h3>I believe something went wrong</h3>;
}

export default function Wrapper({ children }: Readonly<WrapperProps>) {
  return (
    <AppInsightsErrorBoundary onError={ErrorDisplay} appInsights={reactPlugin}>
      <React.StrictMode>
        <QueryClientProvider client={queryClient}>
          {children}
        </QueryClientProvider>
      </React.StrictMode>
    </AppInsightsErrorBoundary>
  );
}
